import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query lookupConfig($id: String!) {
    lookups {
      config {
        byId(_id: $id) {
          _id
          name
          fields {
            title
            key
            component {
              type
              props
            }
          }
          relationships {
            model
            title
            key
            link
          }
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type LookupConfig = NonNullable<NonNullable<NonNullable<NonNullable<TData>['lookups']>['config']>['byId']>

const useLookupConfig = (id: string): LookupConfig | undefined => {
  const { data } = useGraphQL(document, { id }, {
    enabled: typeof id === 'string'
  })
  return data?.lookups?.config?.byId ?? undefined
}

export { useLookupConfig, document as lookupConfigDocument }
